<template>
  <v-card class="mb-4">
    <v-card-title style="background: #eeeeee" tile>
      {{ group.name }}
      <v-dialog v-model="dialogEditGroup" persistent max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon class="ml-3">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <v-card tile>
          <v-card-title>
            <span class="headline">{{ $t("groupRename") }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :label="$t('groupName') + '*'"
              name="group"
              type="text"
              required
              v-model="group.name"
              :error-messages="groupNameErrors"
              @input="$v.group.name.$touch()"
              @blur="$v.group.name.$touch()"
            ></v-text-field>
            <small>* {{ $t("validation") }}</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              :disabled="$v.$invalid"
              text
              @click="editGroup(group), (dialogEditGroup = false)"
              >{{ $t("btnSave") }}</v-btn
            >
            <v-btn
              color="red darken-1"
              text
              @click="loadLocation(location.id), (dialogEditGroup = false)"
              >{{ $t("btnCancel") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogRemoveGroup" persistent max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon class="ml-1">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <v-card tile>
          <v-card-title>
            <span class="headline"
              >{{ $t("groupDelete") }} {{ group.name }}?</span
            >
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="removeGroup(group.id), (dialogRemoveGroup = false)"
              >{{ $t("btnYes") }}</v-btn
            >
            <v-btn
              color="red darken-1"
              text
              @click="dialogRemoveGroup = false"
              >{{ $t("btnNo") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogQrCode" persistent max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon class="ml-1">
            <v-icon>mdi-qrcode</v-icon>
          </v-btn>
        </template>
        <v-card tile>
          <v-card-title>
            <span class="headline"
              >{{ $t("groupQRtitle") }}: {{ group.name }}</span
            >
          </v-card-title>
          <v-card-text>
            <vue-qrcode
              id="qrcode"
              :value="`${newSiteUrl}/${language}/${location.city_slug}/booking_express?group=${group.id}`"
              tag="svg"
              class="qrcode mt-3 mb-3"
              :options="{ margin: 0 }"
            ></vue-qrcode>
            <small class="d-block text-center"
              ><strong>URL: </strong
              >{{
                `${newSiteUrl}/${language}/${location.city_slug}/booking_express?group=${group.id}`
              }}</small
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="downloadQrCode">{{
              $t("btnDownload")
            }}</v-btn>
            <v-btn color="red darken-1" text @click="dialogQrCode = false">{{
              $t("btnCancel")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left" width="5%">#</th>
            <th class="text-left">
              {{ $t("groupSchedule") }}
              <v-btn
                class="ml-1 mb-1"
                :to="{
                  name: 'new_schedule',
                  params: { location_id: location.id, group_id: group.id },
                }"
                icon
              >
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </th>
            <th class="text-left" width="15%">{{ $t("groupStatus") }}</th>
            <th class="text-left" width="15%">{{ $t("groupBegin") }}</th>
            <th class="text-left" width="20%">{{ $t("groupManage") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(schedule, k) in filterLocationSchedules(group.id)"
            :key="k"
          >
            <td>{{ k + 1 }}</td>
            <td>{{ schedule.name }}</td>
            <td>
              {{ schedule.disabled ? $t("groupDisabled") : $t("groupEnabled") }}
            </td>
            <td>
              {{
                schedule.start_dt
                  ? moment(schedule.start_dt).format("DD.MM.YYYY")
                  : "-"
              }}
            </td>
            <td>
              <v-btn
                v-if="!schedule.disabled"
                icon
                @click="changeScheduleStatus(schedule.id)"
              >
                <v-icon>mdi-eye-off</v-icon>
              </v-btn>
              <v-btn v-else icon @click="changeScheduleStatus(schedule.id)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
              <v-btn
                class="ml-1"
                :to="{
                  name: 'schedule',
                  params: {
                    schedule_id: schedule.id,
                    location_id: location.id,
                  },
                }"
                icon
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon class="ml-1" @click="cloneSchedule(schedule.id)">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
              <v-dialog v-model="dialogRemoveSchedule[k]" max-width="800px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon class="ml-1" v-bind="attrs" v-on="on">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <v-card tile>
                  <v-card-title class="headline"
                    >{{ $t("groupSure") }} ({{ schedule.name }})</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="green darken-1"
                      text
                      @click="
                        removeSchedule({ id: schedule.id }),
                          (dialogRemoveSchedule[k] = false)
                      "
                      >{{ $t("btnYes") }}</v-btn
                    >
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogRemoveSchedule[k] = false"
                      >{{ $t("btnNo") }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left blue--text" width="5%">#</th>
            <th class="text-left blue--text">{{ $t("groupPlayground") }}</th>
            <th class="text-left blue--text" width="15%">
              {{ $t("groupType") }}
            </th>
            <th class="text-left blue--text" width="35%">
              {{ $t("groupDuration") }}
            </th>
          </tr>
        </thead>
        <draggable
          :list="group.playgrounds"
          :id="group.id"
          group="playgrounds"
          tag="tbody"
          @end="onEnd"
          :empty-insert-threshold="50"
        >
          <tr
            v-for="(playgroundId, k) in group.playgrounds"
            :key="k"
            :playgroundId="playgroundId"
          >
            <td>{{ k + 1 }}</td>
            <td>
              {{
                location.playgrounds.find((el) => {
                  return el.id == playgroundId;
                }).name
              }}
            </td>
            <td>
              {{
                location.playgrounds.find((el) => {
                  return el.id == playgroundId;
                }).types
              }}
            </td>
            <td>
              {{
                location.playgrounds.find((el) => {
                  return el.id == playgroundId;
                }).duration +
                " " +
                $t("groupMin")
              }}.
            </td>
          </tr>
        </draggable>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import draggable from "vuedraggable";
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  name: "PlaygroundGroup",

  mixins: [validationMixin],

  props: ["group"],

  data() {
    return {
      dialogEditGroup: false,
      dialogRemoveGroup: false,
      dialogQrCode: false,
      dialogRemoveSchedule: {},
      newSiteUrl: process.env.VUE_APP_NEW_SITE_URL,
    };
  },

  computed: {
    ...mapGetters(["location", "locationSchedules", "language"]),
    groupNameErrors() {
      const errors = [];
      if (!this.$v.group.name.$dirty) return errors;
      !this.$v.group.name.required &&
        errors.push(this.$i18n.t("validationGroupName"));
      return errors;
    },
  },

  components: {
    draggable,
    VueQrcode,
  },

  validations: {
    group: {
      name: {
        required,
      },
    },
  },

  methods: {
    ...mapActions([
      "removeGroup",
      "editGroup",
      "loadLocation",
      "changeScheduleStatus",
      "removeSchedule",
      "cloneSchedule",
      "changePlaygroundGroup",
    ]),
    filterLocationSchedules(groupId) {
      return this.locationSchedules.filter((el) => {
        return el.playground_group == groupId;
      });
    },
    onEnd(event) {
      // D&D
      this.changePlaygroundGroup({
        playgroundId: event.clone.attributes.playgroundId.value,
        groupId: event.to.id,
      });
    },
    downloadQrCode(event) {
      const svgContent = document.getElementById("qrcode").innerHTML,
        blob = new Blob([svgContent], {
          type: "image/svg+xml",
        }),
        anchor = document.createElement("a");

      anchor.href = window.URL.createObjectURL(blob);
      anchor.target = "_blank";
      anchor.download = "qrcode.svg";
      anchor.click();
      this.dialogQrCode = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.qrcode {
  width: 100%;
}
</style>
